export default "__VITE_ASSET__fd0e6ac8__"